import { apiClient } from '@/api/client'

export type RelatedKind = 'memo' | 'product_note' | 'highlight'

export type RelatedItem = {
  /** passage: AI 解析済みの他の本の本文（ref_id は本文の断片の id） */
  kind: 'card' | 'memo' | 'highlight' | 'book' | 'passage'
  ref_id: number
  /** カード・メモはタイトル、ハイライト・本文は出典（作品名・話）、本は作品名 */
  title: string
  /** ハイライトは本文、それ以外は本文の先頭 */
  snippet: string
  /** 0〜1（コサイン類似度） */
  similarity: number
  color: string | null
  note: string | null
  /** ハイライト・本文 */
  episode_id: number | null
  /** 本文のみ。リーダーで開く位置キー */
  key: number | null
}

export type RelatedResponse = {
  items: RelatedItem[]
  /** まだ埋め込みを作っていない件数 */
  pending: number
}

/** 意味の近い、まだつながっていないカード・メモ・他の本のハイライト・本 */
export const getRelated = async (kind: RelatedKind, refId: number): Promise<RelatedResponse> => {
  const res = await apiClient.get<RelatedResponse>('/related', { params: { kind, ref_id: refId } })
  return res.data
}

/** ハイライトをカード（メモ）の末尾に引用として足す */
export const appendHighlightToMemo = async (memoId: number, highlightId: number): Promise<void> => {
  await apiClient.post(`/related/memos/${memoId}/highlights`, { highlight_id: highlightId })
}

export type SimilarCard = { memo_id: number; title: string; snippet: string; similarity: number }

/** 作ろうとしているカードと似たことを書いた自分のカード（似たものが無ければ空） */
export const findSimilarCards = async (text: string): Promise<SimilarCard[]> => {
  const res = await apiClient.post<{ items: SimilarCard[] }>('/related/similar-cards', { text })
  return res.data.items
}
